import { createAction } from 'redux-actions'
import {
  ADD_EXPENSE_CATEGORY,
  ADD_EXPENSE_CATEGORY_FAILED,
  ADD_EXPENSE_CATEGORY_SUCCEEDED,
  CLEAR_CREATED_EXPENSE_CATEGORY,
  DELETE_EXPENSE_CATEGORY,
  DELETE_EXPENSE_CATEGORY_FAILED,
  DELETE_EXPENSE_CATEGORY_SUCCEEDED,
  GET_EXPENSE_CATEGORIES,
  GET_EXPENSE_CATEGORIES_FAILED,
  GET_EXPENSE_CATEGORIES_SUCCEEDED,
} from 'Redux/Types/ExpenseCategoryTypes'

export const addExpenseCategory = createAction(ADD_EXPENSE_CATEGORY)
export const clearCreatedExpenseCategory = createAction(CLEAR_CREATED_EXPENSE_CATEGORY)
export const addExpenseCategoryFailed = createAction(ADD_EXPENSE_CATEGORY_FAILED)
export const addExpenseCategorySucceeded = createAction(ADD_EXPENSE_CATEGORY_SUCCEEDED)

export const deleteExpenseCategory = createAction(DELETE_EXPENSE_CATEGORY)
export const deleteExpenseCategoryFailed = createAction(DELETE_EXPENSE_CATEGORY_FAILED)
export const deleteExpenseCategorySucceeded = createAction(DELETE_EXPENSE_CATEGORY_SUCCEEDED)

export const getExpenseCategories = createAction(GET_EXPENSE_CATEGORIES)
export const getExpenseCategoriesFailed = createAction(GET_EXPENSE_CATEGORIES_FAILED)
export const getExpenseCategoriesSucceeded = createAction(GET_EXPENSE_CATEGORIES_SUCCEEDED)
